import { ContentMethodEmbed, ContentMethodRichText } from "../../manage/methods"

export default {
  EMBED: {
    key: "VideoEmbed",
    fieldsData: {
      video_embed_link: {
        placeholder: "Paste url to video",
        action_prompt: "Load video"
      },
      content_embed_code: {
        placeholder: "Paste embed code to video",
        action_prompt: "Load video"
      }
    },
    getValues(content) {
      const embed =
        (content != null ? content.content_embed_code : undefined) ||
        (content != null ? content.video_embed_code : undefined) ||
        (content != null ? content.embed_code : undefined)
      const values = {
        video_embed_link: {
          embed_link: content != null ? content.video_embed_link : undefined,
          embed_code: embed
        },
        content_embed_code: embed
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        video_embed_link:
          fieldsData.video_embed_link.value != null
            ? fieldsData.video_embed_link.value.embed_link
            : undefined,
        content_embed_code: fieldsData.content_embed_code.value
      }
      return saveData
    },
    renderForm({ fieldsData }) {
      let defaultMode
      const { content_embed_code, video_embed_link } = fieldsData
      if (
        content_embed_code.value &&
        !(video_embed_link.value != null
          ? video_embed_link.value.embed_link
          : undefined)
      ) {
        defaultMode = "embed_code"
      } else {
        defaultMode = "embed_link"
      }
      return (
        <ContentMethodEmbed
          defaultMode={defaultMode}
          linkProps={fieldsData.video_embed_link}
          codeProps={fieldsData.content_embed_code}
        />
      )
    }
  },

  LISTED: {
    key: "VideoListed",
    fieldsData: {
      listed_instructions: {
        placeholder: "Write or paste in the video content..."
      }
    },
    getValues(content) {
      const values = {
        listed_instructions:
          content != null ? content.listed_instructions : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        listed_instructions: fieldsData.listed_instructions.value
      }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText
          {...Object.assign({}, fieldsData.listed_instructions)}
        />
      )
    }
  }
}
